import React from 'react';
import PropTypes from 'prop-types';

import QuantiteArticleIncorrecteStep from './QuantiteArticleIncorrecteStep';
import PasBonProduitStep from './PasBonProduitStep';
import DefautProduitManqueAccessoireStep from './DefautProduitManqueAccessoireStep';
import DefautProduitAspectDeballageStep from './DefautProduitAspectDeballageStep';
import DefautProduitStep from './DefautProduitStep';
import DefautProduitSAVAutoriseStep from './DefautProduitSAVAutoriseStep';
import AucunColisArriveStep from './AucunColisArriveStep';
import ManqueColisStep from './ManqueColisStep';
import ColisAbimeStep from './ColisAbimeStep';
import ColisErreurDestinataireStep from './ColisErreurDestinataireStep';
import LivraisonSansPresenceStep from './LivraisonSansPresenceStep';
import RetourPhysiqueSansDossierStep from './RetourPhysiqueSansDossierStep';
import ClientPasRetirerMarchandiseStep from './ClientPasRetirerMarchandiseStep';
import InterneStep from './InterneStep';
import SouffranceStep from './SouffranceStep';
import DemandeRetourMarchandiseLivreeConformeStep from './DemandeRetourMarchandiseLivreeConformeStep';
import AppelTransportStep from './AppelTransportStep';
import DemandeChangementAdresseStep from './DemandeChangementAdresseStep';

import { QualificationCodes } from 'constants.js';

class QualificationStepFactory extends React.Component {

    render() {
        const { reclamation, onClose, onChange, onDetailChange, onDetailsOveride, onSelectPiece, onAddLigne, onRemoveLigne, onLigneOuColisChange,
            onAddColis, onRemoveColis, validationErrors, onNextStepValid, namespace, onSelectAllLignes, onCheckErrors, onAddRetour,
            onRemoveRetour, onJokerFraisRetourChange, autoriseSAV, utilisateurMagasin } = this.props;


        switch (reclamation.qualification.code) {
            case QualificationCodes.AucunColis: { // Commande pas arrivee.
                return (
                    <AucunColisArriveStep
                        reclamation={reclamation}
                        onChange={onChange}
                        onDetailChange={onDetailChange}
                        onSelectPiece={onSelectPiece}
                        onNextStepValid={onNextStepValid}
                        namespace={namespace}
                        utilisateurMagasin={utilisateurMagasin}
                    />
                );
            }
            case QualificationCodes.ManqueColis: { // Manque colis.
                return (
                    <ManqueColisStep
                        reclamation={reclamation}
                        onChange={onChange}
                        onDetailChange={onDetailChange}
                        onSelectPiece={onSelectPiece}
                        onAddLigne={onAddLigne}
                        onRemoveLigne={onRemoveLigne}
                        onLigneOuColisChange={onLigneOuColisChange}
                        onAddColis={onAddColis}
                        onRemoveColis={onRemoveColis}
                        onNextStepValid={onNextStepValid}
                        namespace={namespace}
                        utilisateurMagasin={utilisateurMagasin}
                    />
                );
            }
            case QualificationCodes.ColisAbime: { // Colis abime.
                return (
                    <ColisAbimeStep
                        reclamation={reclamation}
                        onChange={onChange}
                        onDetailChange={onDetailChange}
                        onSelectPiece={onSelectPiece}
                        onAddLigne={onAddLigne}
                        onRemoveLigne={onRemoveLigne}
                        onNextStepValid={onNextStepValid}
                        namespace={namespace}
                        utilisateurMagasin={utilisateurMagasin}
                    />
                );
            }
            case QualificationCodes.ColisPasPourMoi: { // Colis erreur destinataire.
                return (
                    <ColisErreurDestinataireStep
                        reclamation={reclamation}
                        onChange={onChange}
                        onDetailChange={onDetailChange}
                        onSelectPiece={onSelectPiece}
                        onAddLigne={onAddLigne}
                        onRemoveLigne={onRemoveLigne}
                        onNextStepValid={onNextStepValid}
                        namespace={namespace}
                    />
                );
            }
            case QualificationCodes.QuantiteIncorrecte: { // Quantite article incorrecte.
                return (
                    <QuantiteArticleIncorrecteStep
                        reclamation={reclamation}
                        onChange={onChange}
                        onDetailChange={onDetailChange}
                        onSelectPiece={onSelectPiece}
                        onAddLigne={onAddLigne}
                        onRemoveLigne={onRemoveLigne}
                        validationErrors={validationErrors}
                        onNextStepValid={onNextStepValid}
                        namespace={namespace}
                        utilisateurMagasin={utilisateurMagasin}
                        onAddRetour={onAddRetour}
                        onRemoveRetour={onRemoveRetour}
                    />
                );
            }
            case QualificationCodes.PasBonProduit: { // Pas reçu le bon produit / Pas commandé ce produit
                return (
                    <PasBonProduitStep
                        reclamation={reclamation}
                        onChange={onChange}
                        onDetailChange={onDetailChange}
                        onSelectPiece={onSelectPiece}
                        onAddLigne={onAddLigne}
                        onRemoveLigne={onRemoveLigne}
                        validationErrors={validationErrors}
                        onNextStepValid={onNextStepValid}
                        namespace={namespace}
                        onSelectAllLignes={onSelectAllLignes}
                        utilisateurMagasin={utilisateurMagasin}
                        onAddRetour={onAddRetour}
                        onRemoveRetour={onRemoveRetour}
                    />
                );
            }
            case QualificationCodes.DefautProduitManqueAccessoire: { // Défaut produit : manque accessoire.
                return (
                    <DefautProduitManqueAccessoireStep
                        reclamation={reclamation}
                        onChange={onChange}
                        onDetailChange={onDetailChange}
                        onSelectPiece={onSelectPiece}
                        onAddLigne={onAddLigne}
                        onRemoveLigne={onRemoveLigne}
                        validationErrors={validationErrors}
                        onNextStepValid={onNextStepValid}
                        namespace={namespace}
                        utilisateurMagasin={utilisateurMagasin}
                    />
                );
            }
            case QualificationCodes.Sav:
            case QualificationCodes.DefautProduitPremiereUtilisation: { // Défaut produit : première utilisation & SAV

                if (autoriseSAV) {
                    return (
                        <DefautProduitSAVAutoriseStep
                            reclamation={reclamation}
                            onChange={onChange}
                            onDetailChange={onDetailChange}
                            onSelectPiece={onSelectPiece}
                            onAddLigne={onAddLigne}
                            onRemoveLigne={onRemoveLigne}
                            validationErrors={validationErrors}
                            onNextStepValid={onNextStepValid}
                            namespace={namespace}
                            utilisateurMagasin={utilisateurMagasin}
                        />
                    );
                }

                return (
                    <DefautProduitStep
                        reclamation={reclamation}
                        onChange={onChange}
                        onDetailChange={onDetailChange}
                        onSelectPiece={onSelectPiece}
                        onAddLigne={onAddLigne}
                        onRemoveLigne={onRemoveLigne}
                        validationErrors={validationErrors}
                        onNextStepValid={onNextStepValid}
                        namespace={namespace}
                        utilisateurMagasin={utilisateurMagasin}
                    />
                );
            }
            case QualificationCodes.DefautProduitAspectDeballage: { // Défaut produit : Défaut aspect déballage.
                return (
                    <DefautProduitAspectDeballageStep
                        reclamation={reclamation}
                        onChange={onChange}
                        onDetailChange={onDetailChange}
                        onSelectPiece={onSelectPiece}
                        onAddLigne={onAddLigne}
                        onRemoveLigne={onRemoveLigne}
                        validationErrors={validationErrors}
                        onNextStepValid={onNextStepValid}
                        namespace={namespace}
                        utilisateurMagasin={utilisateurMagasin}
                    />
                );
            }
            case QualificationCodes.LivraisonSansPresence: { // Livraison sans ma présence.
                return (
                    <LivraisonSansPresenceStep
                        reclamation={reclamation}
                        onChange={onChange}
                        onDetailChange={onDetailChange}
                        onSelectPiece={onSelectPiece}
                        onAddLigne={onAddLigne}
                        onRemoveLigne={onRemoveLigne}
                        validationErrors={validationErrors}
                        onNextStepValid={onNextStepValid}
                        namespace={namespace}
                    />
                );
            }
            case QualificationCodes.RetourPhysiqueSansDossier:
            case QualificationCodes.DossierEnAttente:
                {
                    return (
                        <RetourPhysiqueSansDossierStep
                            reclamation={reclamation}
                            onChange={onChange}
                            onSelectPiece={onSelectPiece}
                            onAddLigne={onAddLigne}
                            onRemoveLigne={onRemoveLigne}
                            validationErrors={validationErrors}
                            onNextStepValid={onNextStepValid}
                            namespace={namespace}
                        />
                    );
                }
            case QualificationCodes.ClientPasRetirerMarchandise: {
                return (
                    <ClientPasRetirerMarchandiseStep
                        reclamation={reclamation}
                        onChange={onChange}
                        onDetailChange={onDetailChange}
                        onSelectPiece={onSelectPiece}
                        onAddLigne={onAddLigne}
                        onRemoveLigne={onRemoveLigne}
                        validationErrors={validationErrors}
                        onNextStepValid={onNextStepValid}
                        namespace={namespace}
                        onSelectAllLignes={onSelectAllLignes}
                    />
                );
            }
            // Interne
            case QualificationCodes.Interne:
            case QualificationCodes.RetourAttenduSuiteReclamation:
                {
                    return (
                        <InterneStep
                            reclamation={reclamation}
                            onChange={onChange}
                            validationErrors={validationErrors}
                            onNextStepValid={onNextStepValid}
                        />
                    );
                }
            case QualificationCodes.ColisRefuse:
            case QualificationCodes.AdresseErroneeInconnue:
            case QualificationCodes.ContactTelephoneManquant:
            case QualificationCodes.AbsentAviseNeRepondPas:
            case QualificationCodes.ColisImpresentable:
            case QualificationCodes.RefusDeLivraisonPartiel:
            case QualificationCodes.RetardAcheminement:
            case QualificationCodes.RetardExpedition:
            case QualificationCodes.NonConnu:
            case QualificationCodes.ColisMatieresDangeureusesOuInflammables:
            case QualificationCodes.ColisDeterioreAReconditionner:
            case QualificationCodes.ColisEnDestruction:
            case QualificationCodes.ColisRetourneChezLExpediteur: {
                return (
                    <SouffranceStep
                        reclamation={reclamation}
                        onChange={onChange}
                        onDetailChange={onDetailChange}
                        onSelectPiece={onSelectPiece}
                        onAddLigne={onAddLigne}
                        onRemoveLigne={onRemoveLigne}
                        onLigneOuColisChange={onLigneOuColisChange}
                        onAddColis={onAddColis}
                        onRemoveColis={onRemoveColis}
                        onNextStepValid={onNextStepValid}
                        namespace={namespace}
                    />
                );
            }
            // Toutes les qualifications de la catégorie "Demande de retour marchandise livrée conforme" utilisent le même formulaire
            case QualificationCodes.TropCommande:
            case QualificationCodes.PlusUsage:
            case QualificationCodes.NeConvientpas:
            case QualificationCodes.PasCommande: {
                return (
                    <DemandeRetourMarchandiseLivreeConformeStep
                        reclamation={reclamation}
                        onChange={onChange}
                        onDetailChange={onDetailChange}
                        onSelectPiece={onSelectPiece}
                        onAddLigne={onAddLigne}
                        onRemoveLigne={onRemoveLigne}
                        validationErrors={validationErrors}
                        onNextStepValid={onNextStepValid}
                        namespace={namespace}
                        onSelectAllLignes={onSelectAllLignes}
                        onCheckErrors={onCheckErrors}
                        onAddRetour={onAddRetour}
                        onRemoveRetour={onRemoveRetour}
                        onJokerFraisRetourChange={onJokerFraisRetourChange}
                        onClose={onClose}
                        utilisateurMagasin={utilisateurMagasin}
                    />
                );
            }

            // Spéciale transport
            case QualificationCodes.AppelTransport:
                {
                    return (
                        <AppelTransportStep
                            reclamation={reclamation}
                            onChange={onChange}
                            validationErrors={validationErrors}
                            onNextStepValid={onNextStepValid}
                            namespace={namespace}
                            onSelectPiece={onSelectPiece}
                        />
                    );
                }

            // Spéciale transport
            case QualificationCodes.DemandeChangementAdresse:
            case QualificationCodes.ChangementAdresse:            // Pas atteignable normalement
            case QualificationCodes.ModificationAdresseLivraison: // Pas atteignable normalement
                {
                    return (
                        <DemandeChangementAdresseStep
                            reclamation={reclamation}
                            onChange={onChange}
                            // onDetailChange={onDetailChange} // OBSOLETE 
                            onDetailsOveride={onDetailsOveride}
                            validationErrors={validationErrors}
                            onNextStepValid={onNextStepValid}
                            namespace={namespace}
                            onSelectPiece={onSelectPiece}
                        />
                    );
                }

            default: {
                return <div>Aucun formulaire sélectionné</div>;
            }
        }
    }
}

QualificationStepFactory.propTypes = {
    reclamation: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    onCheckErrors: PropTypes.func.isRequired,
    onDetailChange: PropTypes.func.isRequired,
    onDetailsOveride: PropTypes.func.isRequired,
    onSelectPiece: PropTypes.func.isRequired,
    onAddLigne: PropTypes.func.isRequired,
    onRemoveLigne: PropTypes.func.isRequired,
    onLigneOuColisChange: PropTypes.func.isRequired,
    onAddColis: PropTypes.func.isRequired,
    onRemoveColis: PropTypes.func.isRequired,
    validationErrors: PropTypes.array.isRequired,
    onNextStepValid: PropTypes.func.isRequired,
    namespace: PropTypes.string.isRequired,
    onAddRetour: PropTypes.func.isRequired,
    onRemoveRetour: PropTypes.func.isRequired,

    utilisateurMagasin: PropTypes.bool.isRequired,
};

export default QualificationStepFactory;